import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { faCoins, faHeartPulse } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
import { forkJoin } from 'rxjs';
import { ModalAlertValidacaoCadastralComponent } from 'src/app/shared/modals/modal-alert-validacao-cadastral/modal-alert-validacao-cadastral.component';
import { ModalVencimentoPlanoComponent } from 'src/app/shared/modals/modal-vencimento-plano/modal-vencimento-plano.component';
import { TokenService } from 'src/app/shared/services/token.service';
import { UsuarioService } from 'src/app/shared/services/usuario.service';
import { PeculioService } from '../../services/previdencia/peculio.service';
import { AceitesService } from '../../services/saude/aceites.service';
import { WhatsappService } from '../../services/whatsapp/whatsapp.service';
@Component({ selector: 'app-home', templateUrl: './home.component.html', styleUrls: ['./home.component.css'] })
export class HomeComponent implements OnInit {
  actualUser: any;
  healthProfile: any;
  socialSecurityProfile: any;
  isVisible: boolean = false;
  //Icones
  faCoins = faCoins;
  faHeartPulse = faHeartPulse;
  constructor(private router: Router, private usuarioService: UsuarioService, private peculioService: PeculioService, private route: ActivatedRoute, private tokenService: TokenService, private modalService: NgbModal, private whatsappService: WhatsappService, private cookieService: CookieService, private aceitesService: AceitesService) {
    this.getPerfil();
    this.whatsappService.GetMessages().subscribe(
      (res: any) => {
        //  this.data.data = res;
        if (res.length > 0 && this.cookieService.get('vencimentoPlano') == "" || this.cookieService.get('vencimentoPlano') == null) {
          const modalRef = this.modalService.open(ModalVencimentoPlanoComponent, { windowClass: 'carteirinha-modal-size', centered: true });
          modalRef.componentInstance.dependentes = res;
        }
      }
    );
    // const modalRef = this.modalService.open(ModalVencimentoPlanoComponent, { size: 'lg', centered: true });
    this.actualUser = this.tokenService.getActiveUser();
    if (this.actualUser && this.actualUser.socialSecurityProfile) {
      this.socialSecurityProfile = this.actualUser.socialSecurityProfile.description + ' - ' + this.actualUser.socialSecurityProfile.statusDescription;
    } else {
      this.socialSecurityProfile = null;
    }
    if (this.actualUser && this.actualUser.healthProfile) {
      this.healthProfile = this.actualUser.healthProfile.description + ' - ' + this.actualUser.healthProfile.statusDescription;
    } else {
      this.healthProfile = null;
    }
  }
  ngOnInit() {
    if ((this.cookieService.get('aceites') != "" || this.cookieService.get('aceites') != null)) {
      this.aceitesService.GetRecadastramento().subscribe((res: any) => {
        if (res.mostrarPopUp) {
          const modalRef = this.modalService.open(ModalAlertValidacaoCadastralComponent, { centered: true, backdrop: 'static', size: 'lg' });
          modalRef.componentInstance.recadastramento = res;
        }
      });
    }
  }
  atualizarUsuarioLogado(socialSecurityProfile: any | null, healthProfile: any | null) {
    let actualUser = this.tokenService.getActiveUser();
    this.tokenService.removeLoggedUser();
    actualUser.socialSecurityProfile = socialSecurityProfile;
    actualUser.healthProfile = healthProfile;
    this.tokenService.setLoggedUser(actualUser);
    const peculioObs = this.peculioService.getPeculio();
    const profilesObs = this.usuarioService.getProfiles();
    forkJoin([peculioObs, profilesObs]).subscribe({
      next: ([peculioRes, profilesRes]) => {
        let peculio = peculioRes as any;
        let profile = profilesRes as any;
        actualUser.hasPdvPermission = profile.hasPdvPermission;
        actualUser.hasBpdPermission = profile.hasBpdPermission;
        actualUser.hasBsaPermission = profile.hasBsaPermission;
        if (peculio?.length > 0) {
          actualUser.peculio = 1;
        }
        this.tokenService.removeLoggedUser();
        this.tokenService.setLoggedUser(actualUser);
      },
    });
  }
  getPerfil() {
    let actualUser = this.tokenService.getActiveUser();
    if (!actualUser.socialSecurityProfile && !actualUser.healthProfile) {
      this.usuarioService.getProfiles().subscribe((perfil: any) => {
        let redirect = "home";
        this.route.queryParams.subscribe((params: any) => {
          if (params.redirect && params.redirect != "" && params.redirect != "undefined") {
            redirect = params.redirect;
          }
          //sem perfil
          if (perfil.socialSecurity?.length === 0 && perfil.health?.length === 0) {
            this.router.navigate(["/access-denied"]);
          } //apenas 1 perfil de saude
          else if (perfil.socialSecurity?.length == 0 && perfil.health?.length >= 1) {
            perfil.health[0].multiplo = false;
            this.atualizarUsuarioLogado(null, perfil.health[0]);
            this.router.navigate([redirect]);
          } //apenas 1 perfil de previdencia
          else if (perfil.socialSecurity?.length >= 1 && perfil.health?.length == 0) {
            perfil.socialSecurity[0].multiplo = false;
            this.atualizarUsuarioLogado(perfil.socialSecurity[0], null);
            this.router.navigate([redirect]);
          } //apenas 1 perfil de ambos os produtos
          else if (perfil.socialSecurity?.length >= 1 && perfil.health?.length >= 1) {
            if (perfil.socialSecurity?.length == 1)
              perfil.socialSecurity[0].multiplo = false;
            if (perfil.health?.length == 1)
              perfil.health[0].multiplo = false;
            this.atualizarUsuarioLogado(perfil.socialSecurity[0], perfil.health[0]);
            this.router.navigate([redirect]);
          } //mais de 1 perfil
          else {
            if (perfil.socialSecurity?.length > 1) {
              perfil.socialSecurity.forEach((p: any) => p.multiplo = true);
            }
            if (perfil.health?.length > 1) {
              perfil.health.forEach((p: any) => p.multiplo = true);
            }
          }
        });
      });
    }
  }
}
